import React from 'react';


import { Modal, Spin, Table } from 'antd';
import Title from 'antd/es/typography/Title';
import * as _ from 'lodash';

type IOtherGeneralCommentComponentProps = {
    isOpen: boolean;
    onClose: () => void;
    data: any;
    isLoading: boolean;
};

export const OtherGeneralCommentComponent = ({ isOpen, onClose, data, isLoading }: IOtherGeneralCommentComponentProps) => {
    const columns = [
        {
            title: <span className='fw-bold'>Người ý kiến</span>,
            key: 'evaluateLevelName',
            width: 250,
            render: item => item?.performerName ? `${item?.evaluateLevelName} - ${item?.performerName}` : item?.evaluateLevelName
        },
        {
            title: <span className='fw-bold'>Ý kiến</span>,
            key: 'generalFeedback',
            width: 250,
            dataIndex: 'generalFeedback',
        },
    ]
    return (
        <Modal open={isOpen} maskClosable={false} footer={null} onCancel={onClose} width={'50vw'} className='view'>
            <div className="d-flex pr-1">
                <Title level={3}>Phản hồi chung</Title>
            </div>
            <Table columns={columns} pagination={false} loading={isLoading} dataSource={
                data.map(value => {
                    return {
                        evaluateLevelName: value.versionName,
                        key: value.versionName,
                        children: _.flatMap(value?.otherLevelGeneralFeedbacks, item =>
                            item.performerGeneralFeedbacks?.map(feedback => ({
                                key: feedback.performerName,
                                evaluateLevelName: item.evaluateLevelName,
                                performerName: feedback.performerName,
                                generalFeedback: feedback?.generalFeedback,
                            })))
                    }
                }
                )}
            />
        </Modal>
    );
};

export default OtherGeneralCommentComponent;
